class ArticlesTabController {
  constructor(
    $rootScope,
    $q,
    $filter,
    $stateParams,
    loadSpinnerService,
    ConceptsApiService,
    ArticleDialogService,
    concept,
    customer,
  ) {
    'ngInject';

    if (customer) {
      $rootScope.pageTitle = `${customer.name || ''} - Articles`;
    } else if (concept) {
      $rootScope.pageTitle = `${concept.name || ''} - Articles`;
    }

    this.$q = $q;
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.loadSpinnerService = loadSpinnerService;
    this.ConceptsApiService = ConceptsApiService;
    this.ArticleDialogService = ArticleDialogService;
    this.concept = concept;
    this.customer = customer;
  }
}

angular
  .module('tabs.articles', [])
  .controller('ArticlesTabController', ArticlesTabController);
